import { Method } from 'axios';
import IconButton from 'components/IconButton';
import callApi from 'lib/callApi';
import { showFailureToast } from 'lib/ToastHelper';
import React, { useRef } from 'react';

interface Props {
  buttonId: string;
  iconClass: string;
  tooltip: string;
  uploadUrl: string;
  allowedExtensions: string[];
  method: Method;
  disabled?: boolean;
  className?: string;
  urlParams?: any;
  data?: any;
  headers?: any;
  onSuccessCallback?: (response) => void;
  onFailureCallback?: (message) => void;
}

const FileContentUploaderButton: React.FC<Props> = ({
  buttonId,
  iconClass,
  tooltip,
  uploadUrl,
  method,
  disabled = false,
  className,
  urlParams = {},
  data = null,
  headers = null,
  onSuccessCallback,
  onFailureCallback,
  allowedExtensions,
}) => {
  const inputFileRef = useRef<any>(null);

  const clearInput = () => {
    if (inputFileRef.current) {
      inputFileRef.current.value = '';
    }
  };

  const uploadFileContent = async (event) => {
    const selectedFile = event.target.files[0];
    const fileExtension = selectedFile?.name.split('.').pop()?.toLowerCase();
    if (selectedFile && !allowedExtensions.includes(fileExtension)) {
      showFailureToast('Please input a valid CSV file.');
      return;
    }

    if (selectedFile) {
      const reader = new FileReader();
      reader.onload = async (event) => {
        const csv_data = event.target?.result as string;
        if (uploadUrl) {
          const new_data = {
            company_id: data['company_id'],
            csv_data: csv_data,
          };
          callApi(uploadUrl, method, urlParams, (data = new_data), headers)
            .then((res) => {
              if (res.status === 201 || res.status === 200) {
                if (onSuccessCallback) onSuccessCallback(res.data);
              } else {
                console.error({
                  function: 'uploadFileContent',
                  error: `Unexpected response: ${res.status}`,
                  res,
                });
                if (onFailureCallback)
                  onFailureCallback(
                    'Import bulk alias(es) failed. Please verify data in CSV file and try again.',
                  );
              }
            })
            .catch((err) => {
              console.error({
                function: 'downluploadFileContentoadFile',
                error: err,
              });
              if (onFailureCallback)
                onFailureCallback(
                  'Import bulk alias(es) failed. Please verify data in CSV file and try again.',
                );
            });
        }
        clearInput();
      };
      reader.readAsText(selectedFile);
    }
  };

  return (
    <>
      <input
        type="file"
        ref={inputFileRef}
        style={{ display: 'none' }}
        onChange={uploadFileContent}
        accept=".csv"
      />
      <IconButton
        id={buttonId}
        disabled={disabled}
        iconClass={iconClass}
        tooltip={tooltip}
        onClick={() => {
          if (inputFileRef.current) {
            inputFileRef.current.click();
          }
        }}
        cssClass={className}
      />
    </>
  );
};

export default FileContentUploaderButton;
